/**
 * Admin board detail URL for a grid template (puzzle info, word lists, grid).
 * @param {object} puzzle
 * @param {number|{ returnTo?: string }|null} [fromStepOrOpts=0]
 *   - number: back to grid_board?activeStep=N
 *   - { returnTo }: back to that path (e.g. /admin/puzzle/grid_pack)
 *   - null: bare detail path (back falls through to grid_board)
 */
export function gridBoardDetailPath(puzzle, fromStepOrOpts = 0) {
    const id = puzzle?.id;
    if (!id) {
        return "/admin/puzzle/grid_board";
    }
    const state = String(puzzle?.state || "DRAFT").toUpperCase();
    const segmentByState = {
        DRAFT: "draft",
        READY_TO_REVIEW: "ready-to-review",
        REVIEWED: "reviewed",
        PUBLISHED: "published",
    };
    const segment = segmentByState[state] || "draft";
    const base = `/admin/puzzle/grid_board/${segment}/${id}`;

    if (fromStepOrOpts && typeof fromStepOrOpts === "object") {
        const returnTo = fromStepOrOpts.returnTo;
        if (typeof returnTo === "string" && returnTo.startsWith("/")) {
            return `${base}?returnTo=${encodeURIComponent(returnTo)}`;
        }
        return base;
    }
    if (fromStepOrOpts === null || fromStepOrOpts === false) {
        return base;
    }
    const step = Number.isFinite(Number(fromStepOrOpts)) ? Number(fromStepOrOpts) : 0;
    return `${base}?fromStep=${step}`;
}

/** Shared back navigation for board detail steps. */
export function navigateBoardDetailBack(navigate, searchParams) {
    const returnTo = searchParams.get("returnTo");
    if (returnTo && returnTo.startsWith("/")) {
        navigate(returnTo);
        return;
    }
    const fromStep = searchParams.get("fromStep");
    if (fromStep !== null) {
        navigate(`/admin/puzzle/grid_board?activeStep=${fromStep}`);
        return;
    }
    navigate("/admin/puzzle/grid_board");
}
